import {createSSRApp} from "vue";
import App from "./App.vue";
import store from '@/store';
import axios from 'axios';
import Vant from 'vant';
import 'vant/lib/index.css';
import NutUI from '@nutui/nutui';
import '@nutui/nutui/dist/style.css';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
// 引入阿里 iconfont 样式
import '@/assets/iconfont/iconfont.css';
// import VConsole from "vconsole";

// 初始化 VConsole (建议在开发环境或测试环境开启)
// 如果你只想在特定条件下开启，可以加个判断，比如：
// if (process.env.NODE_ENV === 'development') {
//   new VConsole();
// }

export function createApp() {
	const app = createSSRApp(App);
	app.use(store)
	app.config.globalProperties.$axios = axios
	app.use(Vant)
	app.use(NutUI)
	app.use(ElementPlus)
	return {
		app,
	};
}
